import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import React, { useEffect, useRef } from 'react'
import 'element-closest-polyfill'
import 'url-search-params-polyfill'
import init from './script'
import './index.less'

interface EditorProps {
  staticResourcesUrl: string
  apiPath?: string
}

export function Editor({ staticResourcesUrl, apiPath }: EditorProps) {
  const rootElRef = useRef(null)
  useEffect(() => {
    init(rootElRef.current, staticResourcesUrl, apiPath)
  }, [apiPath, staticResourcesUrl])

  return <div ref={rootElRef} className="ketcher root"></div>
}
